import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Icons } from "@learningblocks/exp-constants";
const { ChevronDownSolid: OpenIcon } = Icons;
import "./style.scss";
import { PlainText } from "@learningblocks/storybook-components";
import { useIntl } from "react-intl";

const ENTER_KEY = 13;

export function ContentDropdown(props) {
  const ref = useRef();
  const intl = useIntl();

  const [open, setOpen] = useState(props.open);
  const [contentHeight, setContentHeight] = useState("none");

  useEffect(() => {
    updateContentHeight();

    window.onresize = function () {
      updateContentHeight();
    };
  }, []);

  const updateContentHeight = () => {
    if (ref.current) {
      setContentHeight(ref.current.scrollHeight + (!open ? 16 : 0));
    }
  };

  const toggleOpen = () => {
    updateContentHeight();
    setOpen(!open);
  };

  return (
    <div className="ContentDropdown_container">
      <div
        className="ContentDropdown_btn"
        role="checkbox"
        aria-checked={open}
        tabIndex="0"
        aria-label={intl.formatMessage(
          {
            id: "Expand the {block} section.",
            defaultMessage: "Expand the {block} section.",
          },
          {
            block:
              props.contentDetails.label !== undefined
                ? props.contentDetails.label
                : intl.formatMessage({
                    id: "Dropdown",
                    defaultMessage: "Dropdown",
                  }),
          }
        )}
        onClick={() => toggleOpen()}
        onKeyDown={(e) => {
          if (e.keyCode === ENTER_KEY) {
            toggleOpen();
          }
        }}
      >
        {props.contentDetails.label === undefined
          ? open
            ? intl.formatMessage({ id: "Collapse", defaultMessage: "Collapse" })
            : intl.formatMessage({ id: "Expand", defaultMessage: "Expand" })
          : intl.formatMessage({
              id: props.contentDetails.label,
              defaultMessage: props.contentDetails.label,
            })}
        <OpenIcon
          className={`ContentDropdown_icon ${open ? "open" : "closed"}`}
          alt=""
        />
      </div>
      <div
        ref={ref}
        className={`ContentDropdown_content ${open ? "open" : "closed"}`}
        aria-hidden={!open}
        style={{
          maxHeight: open ? contentHeight : "0px",
        }}
      >
        <PlainText text={props.contentDetails.content} />
      </div>
    </div>
  );
}

ContentDropdown.propTypes = {
  contentDropdown: PropTypes.shape({
    /**
     * Label that is displayed as the header for the Dropdown
     */
    label: PropTypes.string,
    /**
     * Content that is given to the particular dropdown.
     */
    content: PropTypes.string.isRequired,
    /**
     * Boolean that is used to check whether the dropdown is open or closed
     */
    open: PropTypes.bool.isRequired,
  }),
};

ContentDropdown.defaultProps = {
  contentDropdown: null,
};
